import 'babel-polyfill';
import 'element-closest';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
// import serviceWorker from './utils/serviceWorker';
import { detectUserLanguage } from './utils/i18n';
import { configureStore, selectLocationState } from './store';
import routes from './routes';
import config from './config';
// styles
import './css/index';

const language = detectUserLanguage();
const isDefaultLanguage = config.languages.default === language;
const store = configureStore(browserHistory);
const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: selectLocationState(),
});

function renderApp(locale, messages) {
  addLocaleData(locale);

  render(
    <IntlProvider locale={language} messages={messages}>
      <Provider store={store}>
        <div>
          <Router history={history} routes={routes(store)} />
        </div>
      </Provider>
    </IntlProvider>,
    document.getElementById('root'),
  );

  // serviceWorker();
}

if (isDefaultLanguage) {
  Promise.all([
    import(`react-intl/locale-data/${language}`),
  ]).then(([locale, messages]) => {
    renderApp(locale, messages);
  });
} else {
  Promise.all([
    import(`react-intl/locale-data/${language}`),
    import(`./translations/${language}.json`),
  ]).then(([locale, messages]) => {
    renderApp(locale, messages);
  });
}



// WEBPACK FOOTER //
// ./src/index.js